module.exports = __webpack_public_path__ + "img/clock-resume.4a9d04cf.svg";